module.exports = __webpack_public_path__ + "img/sq-bg3.365356e9.png";